import PropTypes from 'prop-types';

export const BLOG_PROP_TYPES = PropTypes.shape({
  flag: PropTypes.string,
  content: PropTypes.shape({
    taxonomy: PropTypes.shape({
      path: PropTypes.string,
    }),
  }).isRequired,
  activeItems: PropTypes.arrayOf(PropTypes.shape({})),
  path: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  fetchingLatest: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  numberOfNewItems: PropTypes.number.isRequired,
  loadingMoreCards: PropTypes.bool,
  trueTotalItems: PropTypes.number,
  isCanonicalCard: PropTypes.bool,
});

export const BLOG_DEFAULT_PROPS = {
  flag: null,
  activeItems: [],
  fetchingLatest: false,
  loadingMoreCards: false,
  trueTotalItems: null,
  isCanonicalCard: false,
};
